import { getImageUrl } from "Common/utils/ImageDomain";
import Button from "../../Common/Components/ButtonComponent/Button";

const ScrollSegmentCard = ({
  index,
  button,
  handleRemoveIcon,
  toggle,
  setIndex,
  setEventData,
  errors,
  isEditable,
  removeButton,
  isLoading,
  pageId,
  segmentId,
}) => {
  return (
    <>
      <div key={index} className="py-4 xl:col-span-4">
        <div className="bg-white border border-black-600 rounded-[5px] px-4 py-4">
          <div className="flex my-4">
            {button?.image_url ? (
              <div className="flex items-center">
                <div className="relative w-40 h-40 ">
                  <img
                    data-dz-thumbnail
                    className="rounded border-[gray] border"
                    style={{
                      objectFit: "contain",
                      width: "100%",
                      height: "100%",
                    }}
                    src={getImageUrl(button?.image_url)}
                    alt={"img"}
                  />
                  <span
                    style={{
                      position: "absolute",
                      top: "0px",
                      right: "6px",
                      fontSize: "22px",
                      cursor: "pointer",
                    }}
                    onClick={
                      isEditable
                        ? () => {
                            handleRemoveIcon(index);
                          }
                        : null
                    }
                  >
                    ×
                  </span>
                </div>
                <div className="h-3 ml-3">
                  <button
                    onClick={
                      isEditable
                        ? () => {
                            toggle();
                            setEventData(undefined);
                            setIndex(index);
                          }
                        : null
                    }
                    className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                  >
                    Change
                  </button>
                </div>
              </div>
            ) : (
              <button
                onClick={
                  isEditable
                    ? () => {
                        toggle();
                        setEventData(undefined);
                        setIndex(index);
                      }
                    : null
                }
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
              >
                Add imageUrl
              </button>
            )}
          </div>

          {errors?.buttons[index]?.image_url && (
            <p className="mt-2 text-red-500">
              {errors?.buttons[index]?.image_url ||
                errors?.buttons[index]?.image_url}
            </p>
          )}
          <div className="flex justify-end mt-2">
            {/* <button
              onClick={isEditable ? () => removeButton(index) : null}
              className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
            >
              Remove
            </button> */}
            <Button
              btnText="Remove"
              onClick={isEditable ? () => removeButton(index) : null}
              disabled={!isEditable}
              isLoading={isLoading}
              pageId={pageId}
              id={segmentId}
              disabledClassName={
                "text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
              }
              className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default ScrollSegmentCard;
